import React, { Component } from 'react';
import '../../assets/css/cbhistoryapp.css'
import { Table } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';

class TableComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedRow: null,
    };
  }

  handleRowClick = (loanId) => {
    this.setState({ expandedRow: loanId === this.state.expandedRow ? null : loanId });
  };

  renderMicrofinanceDetails = (loan) => {
    return (
      <tr   key={loan.id}>
        <td>{loan.institution}</td>
        <td>{loan.accountNumber}</td>
        <td>{loan.disbursedAmount}</td>
        <td>{loan.lastPaymentDate}</td>
        <td>{loan.accountStatus}</td>
        <td>{loan.daysPastDue}</td>
        <td>{loan.pastDueAmount}</td>
        <td>{loan.WriteOffAmount??0}</td>
        <td>{loan.currentBalance}</td>
        <td>{loan.repaymentTenure}</td>
        <td>{loan.installmentAmount}</td>
        <td>{loan.dateOpened}</td>
        {/* Add other details as needed */}
      </tr>
    );
  };

  renderconsolidatedCreditSummary = (summary) => {
    return (
        <tr className='pointer-cursor' key={summary.id} onClick={() => this.handleRowClick(summary.id)}> 
            <td className='pointer-cursor'>{summary.id}</td>
            <td className='pointer-cursor'>{summary.date}</td>
            <td className='pointer-cursor'>{summary.mfactiveLoanCount}</td>
            <td className='pointer-cursor'>{summary.mfNumberOfDistinctInstitutions}</td>
            <td className='pointer-cursor'>{summary.mfTotalOutstandingBalance}</td>
            <td className='pointer-cursor'>{summary.mfMaxDaysPastDue}</td>
            <td className='pointer-cursor'>{summary.mfTotaldisbursedAmount}</td>
            <td className='pointer-cursor'>{summary.mfTotalPastDueAmount}</td>
            <td className='pointer-cursor'>{summary.mfTotalWriteOff}</td>
            <td className='pointer-cursor'>{summary.mfTotalWriteOffAmount}</td>
            <td className='pointer-cursor'>{summary.mfTotalInstallmentAmount}</td>
            <td className='pointer-cursor'>{summary.rtactiveLoanCount}</td>
            <td className='pointer-cursor'>{summary.rtTotalOutstandingBalance}</td>
            <td className='pointer-cursor'>{summary.rtTotalPastDueAmount}</td>
            <td className='pointer-cursor'>{summary.rtTotalWriteOff}</td>
            <td className='pointer-cursor'>{summary.result}</td>

        </tr>
    );
  };

  renderRetailDetails = (loan) => {
    return (
      <tr   key={loan.id}>
        <td>{loan.institution}</td>
        <td>{loan.accountNumber}</td>
        <td>{loan.sanctionAmount}</td>
        <td>{loan.balance}</td>
        <td>{loan.accountStatus}</td>
        <td>{loan.pastDueAmount}</td>
        <td>{loan.reportedDate}</td>
        {/* Add other details as needed */}
      </tr>
    );
  };

  renderMicroFinanceAccounts = (accounts) => {
    return accounts.map((account) => this.renderMicrofinanceDetails(account));
  };

  renderRetailAccounts = (accounts) => {
    return accounts.map((account) => this.renderRetailDetails(account));
  };


  renderRow = (record) => {
    const { expandedRow } = this.state;
    const {showAllInstitution} = this.props; 
    const retailAccounts = record.retailAccounts.filter(rt => 
      rt.accountStatus!="Closed Account" && 
      rt.accountStatus!="Restructured & Closed" && 
      !rt.institution.toLowerCase().includes("svasti"));

      
    const rtactiveLoanCount = retailAccounts.length;

    const rtTotalOutstandingBalance = retailAccounts.reduce((total, rt) => {
      return total + rt.balance;
    }, 0);

    const custInformation = record.custInfoData;

    const rtTotalPastDueAmount = retailAccounts.reduce((total, rt) => {
      return total + rt.pastDueAmount;
    }, 0);

    const rtTotalWriteOff = record.retailAccounts.filter(rt => rt.accountStatus=="Charge Off/Written Off").length;

    const microFinanceAccounts = record.microFinanceAccounts.filter(mf => 
      mf.accountStatus!="Closed Account" && 
      mf.accountStatus!="Restructured & Closed" && 
      !mf.institution.toLowerCase().includes("svasti") && 
      !mf.institution.toLowerCase().includes("bandhan bank limited") && 
      !mf.institution.toLowerCase().includes("fedbank financial services limited"));

    const microFinanceAccountsForDisplay = record.microFinanceAccounts.filter(mf => 
      mf.accountStatus!="Closed Account" && 
      mf.accountStatus!="Restructured & Closed" && 
      !mf.institution.toLowerCase().includes("svasti") && 
      !mf.institution.toLowerCase().includes("fedbank financial services limited"));

      const microFinanceAccountsForDisplay1 = record.microFinanceAccounts.filter(mf => 
        mf.accountStatus!="Closed Account" && 
        mf.accountStatus!="Restructured & Closed");
  
    let LDD = null;
    let  isLessThan3YearsAndValidBranch = false;
    let branch = null;

    if (custInformation)
    {
      LDD = custInformation.LDD;
      branch = custInformation.BranchName;
    }
    if (LDD && branch) {
      // Calculate the difference in milliseconds between the current date and LDD (Loan Disbursement Date)
      const currentDate = new Date();
      const differenceInMilliseconds = currentDate - LDD;
    
      // Calculate the difference in years
      const yearsDifference = differenceInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
    
      // Compare if the difference is less than 3 years
      // Check if branch is one of the listed branches and the difference is less than 3 years
      const validBranches = ["Bicholim", "Margaon", "Kankavli", "Sawantwadi", "Alibag", "Mangaon", "Pen", "Roha", "Chiplun", "Dapoli", "Ratnagiri"];
      isLessThan3YearsAndValidBranch = yearsDifference < 3 && validBranches.includes(branch);

      if (isLessThan3YearsAndValidBranch) {
        console.log(`Branch ${branch} is one of the valid branches and LDD is less than 3 years from the current date.`);
        // Do something if true
      } else {
        console.log(`Branch ${branch} is either not in the valid branches or LDD is 3 years or more from the current date.`);
        // Do something if false
      }
    } else {
      console.log("Unable to retrieve LDD or branch information.");
    }

    //const consolidatedCreditSummary = record.consolidatedCreditSummary;
    const mfactiveLoanCount = microFinanceAccounts.length;

    
    let distinctInstitutions = new Set(microFinanceAccountsForDisplay.map(mf => mf.institution.toLowerCase()));

    if(showAllInstitution==='true')
    {
      distinctInstitutions = new Set(microFinanceAccountsForDisplay1.map(mf => mf.institution.toLowerCase()));
    }
    // Create a Set of distinct institutions

    // The number of distinct institutions
    const mfNumberOfDistinctInstitutions = distinctInstitutions.size;

    const mfTotalOutstandingBalance = microFinanceAccounts.reduce((total, mf) => {
      return total + mf.currentBalance;
    }, 0);

    const mfMaxDaysPastDue = microFinanceAccountsForDisplay.reduce((max, mf) => mf.daysPastDue > max ? mf.daysPastDue : max, 0);

    const mfTotaldisbursedAmount = microFinanceAccounts.reduce((total, mf) => {
      return total + mf.disbursedAmount;
    }, 0);

    const mfTotalPastDueAmount = microFinanceAccountsForDisplay.reduce((total, mf) => {
      return total + mf.pastDueAmount;
    }, 0);

    //below code is changed as per discussion with Chetan on 12th Jan 2024
    // const mfTotalWriteOff = microFinanceAccountsForDisplay.filter(mf => mf.accountStatus==="Charge Off/Written Off" || mf.accountStatus==='Post Written Off Settled' || mf.accountStatus==='Willful Default').length;

    // const mfTotalWriteOffAmount = microFinanceAccountsForDisplay
    // .filter(mf => mf.accountStatus === "Charge Off/Written Off" || mf.accountStatus === 'Post Written Off Settled' || mf.accountStatus === 'Willful Default')
    // .reduce((total, mf) => {
    //   return total + parseFloat(mf.WriteOffAmount ?? 0 );
    // }, 0);

    const mfTotalWriteOff = microFinanceAccountsForDisplay.filter(mf => mf.WriteOffAmount!=null && mf.WriteOffAmount>0 ).length;
    
    const mfTotalWriteOffAmount = microFinanceAccountsForDisplay
    .reduce((total, mf) => {
      return total + parseFloat(mf.WriteOffAmount ?? 0 );
    }, 0);
  
  console.log(mfTotalWriteOffAmount.toFixed(2)); // Ensure toFixed(2) for displaying two decimal places
  

    const mfTotalInstallmentAmount = microFinanceAccounts.reduce((total, account) => {
      let multiplier = 1; // Default multiplier
      // Convert repaymentTenure to lowercase for case insensitive comparison
      const tenure = account.repaymentTenure.toLowerCase();
  
      switch (tenure) {
        case 'weekly':
          multiplier = 4;
          break;
        case 'bi-weekly':
          multiplier = 2;
          break;
        case 'monthly':
        case 'on-demand':
          multiplier = 1;
          break;
        // Add more cases here if there are other repaymentTenures
        default:
          multiplier = 1; // or handle unexpected repaymentTenure appropriately
      }
    
      return total + (account.installmentAmount * multiplier);
    }, 0);

    // const consolidatedCreditSummary = {
    //   id : record.id,
    //   result : record.Result,
    //   date : record.date,
    //   mfactiveLoanCount : mfactiveLoanCount,
    //   mfTotalOutstandingBalance : mfTotalOutstandingBalance,
    //   mfMaxDaysPastDue: mfMaxDaysPastDue,
    //   mfTotaldisbursedAmount : mfTotaldisbursedAmount,
    //   mfTotalPastDueAmount : mfTotalPastDueAmount,
    //   mfTotalWriteOff : mfTotalWriteOff,
    //   mfTotalWriteOffAmount : mfTotalWriteOffAmount,
    //   mfTotalInstallmentAmount : mfTotalInstallmentAmount,
    //   mfNumberOfDistinctInstitutions : mfNumberOfDistinctInstitutions,
    //   rtactiveLoanCount : rtactiveLoanCount,
    //   rtTotalOutstandingBalance : rtTotalOutstandingBalance,
    //   rtTotalPastDueAmount : rtTotalPastDueAmount,
    //   rtTotalWriteOff : rtTotalWriteOff,
    //   isLessThan3YearsAndValidBranch : isLessThan3YearsAndValidBranch,
    // }

    const consolidatedCreditSummary = {
      id : record.id,
      result : (
        (isLessThan3YearsAndValidBranch && mfTotalOutstandingBalance > 200000) ||
        (!isLessThan3YearsAndValidBranch && mfTotalOutstandingBalance > 150000) ||
        mfTotalWriteOffAmount > 0 ||
        mfTotalPastDueAmount > 0
      ) ? "Failed" : "Passed",
      date : record.date,
      mfactiveLoanCount : mfactiveLoanCount,
      mfTotalOutstandingBalance : mfTotalOutstandingBalance,
      mfMaxDaysPastDue: mfMaxDaysPastDue,
      mfTotaldisbursedAmount : mfTotaldisbursedAmount,
      mfTotalPastDueAmount : mfTotalPastDueAmount,
      mfTotalWriteOff : mfTotalWriteOff,
      mfTotalWriteOffAmount : mfTotalWriteOffAmount,
      mfTotalInstallmentAmount : mfTotalInstallmentAmount,
      mfNumberOfDistinctInstitutions : mfNumberOfDistinctInstitutions,
      rtactiveLoanCount : rtactiveLoanCount,
      rtTotalOutstandingBalance : rtTotalOutstandingBalance,
      rtTotalPastDueAmount : rtTotalPastDueAmount,
      rtTotalWriteOff : rtTotalWriteOff,
      isLessThan3YearsAndValidBranch : isLessThan3YearsAndValidBranch,
    }
    
    return (
      <React.Fragment key={record.id}>
        {this.renderconsolidatedCreditSummary(consolidatedCreditSummary)}
        {expandedRow === record.id && (
          <>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td colSpan="14">
                <Table  striped bordered  hover>
                  {/* Headers for detailed loan data */}
                  <thead>
                    <tr>
                      <th colSpan={15}>
                        <Alert key="primary" variant="primary">
                          <center>Microfinance Accounts</center>
                        </Alert>
                      </th>
                    </tr>
                    <tr>
                      <th>Institution</th>
                      <th>Account Number</th>
                      <th>Disbursed Amount</th>
                      <th>Last Payment Date</th>
                      <th>Account Status</th>
                      <th>Days Past Due</th>
                      <th>Past Due Amount</th>
                      <th>Write Amount</th>
                      <th>Current Balance</th>
                      <th>Repayment Tenure</th>
                      <th>Installment Amount</th>
                      <th>Disbursement Date</th>
                      {/* Add other headers as needed */}
                    </tr>
                  </thead>
                  <tbody>
                  {this.props.showAllInstitution.toLowerCase() === "true" ? 
                    this.renderMicroFinanceAccounts(microFinanceAccountsForDisplay1) :
                    this.renderMicroFinanceAccounts(microFinanceAccountsForDisplay)}
                  </tbody>
                </Table>
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td colSpan="13">
                <Table striped bordered hover>
                  {/* Headers for detailed loan data */}
                  <thead>
                    <tr>
                      <th colSpan={13}>
                        <Alert key="info" variant="info">
                          <center>Retails Accounts</center>
                        </Alert>
                      </th>
                    </tr>
                    <tr>
                      <th>Institution</th>
                      <th>Account Number</th>
                      <th>Sanction Amount</th>
                      <th>Balance Amount</th>
                      <th>Account Status</th>
                      <th>Past Due Amount</th>
                      <th>Reported Date</th>
                      {/* Add other headers as needed */}
                    </tr>
                  </thead>
                  <tbody>
                    {this.renderRetailAccounts(retailAccounts)}
                  </tbody>
                </Table>
              </td>
            </tr>
          </>
          
        )}
      </React.Fragment>
    );
  };

  render() {
    const { data } = this.props; // Assuming 'data' is the array of records from the API
    const sortedRecords = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Sorting in descending order
    const maxId = sortedRecords.reduce((max, cb) => cb.id > max ? cb.id : max, 0);
    // Filter to keep only the record with the maximum id
    //const filteredRecords = sortedRecords.filter(cb => cb.id === maxId);
    // No filteration
    const filteredRecords = sortedRecords;

    return (
      <Table   variant="dark" hover>
        <thead>
          <tr>
            <th className='blueHeader bordered-column' colSpan={11}>
                <center>Microfinance</center>
            </th>
            <th className='blueHeader bordered-column' colSpan={4}>
                <center>Retail</center>
            </th>
            <th className='blueHeader bordered-column'>
                <center>Result</center>
            </th>
          </tr>
          <tr>
            {/* Table headers for summary data */}
            <th className='bordered-column' >CB Id</th>
            <th className='bordered-column' >Date of Enquiry</th>
            <th className='bordered-column' >Active Loans</th>
            <th className='bordered-column' >Distinct Institution</th>
            <th className='bordered-column' >Outstanding Balance</th>
            <th className='bordered-column' >Max Days Past Due</th>
            <th className='bordered-column' >Disbursed Amount</th>
            <th className='bordered-column' >Past Due Amount</th>
            <th className='bordered-column' >Writeoff</th>
            <th className='bordered-column' >WriteoffAmount</th>
            <th className='bordered-column' >Installment</th>
            <th className='bordered-column' >Active Loans</th>
            <th className='bordered-column' >Outstanding Balance</th>
            <th className='bordered-column' >Past Due Amount</th>
            <th className='bordered-column' >Write off</th>
            <th className='bordered-column' >Result</th>
            {/* other headers */}
          </tr>
        </thead>
        <tbody>
          {filteredRecords.map(this.renderRow)}
        </tbody>
      </Table>
    );
  }
}

export default TableComponent;
